<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
        <h1 class="page-title fw-bold">Assignation des composantes P4W</h1>
        <div>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link :to="{ name: 'dashboard' }"><a>Tableau de bord</a></router-link></li>
                <li class="breadcrumb-item" aria-current="page"><router-link :to="{ name: 'composantes', params: { showList: true }}"><a>Portefeuille</a></router-link></li>
                <li class="breadcrumb-item active" aria-current="page"><router-link :to="{ name: 'composantes', params: { showList: true }}"><a>Assignation Composantes P4W</a></router-link></li>
            </ol>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12" v-if="showList">
            <div class="card">
                <div class="card-header">
                    <h3 class="card-title fw-bold">Liste des projets P4W</h3>
                    <div class="card-options">
                        <SearchInputAll></SearchInputAll>
                        <button class="btn btn-outline-dark mx-5" @click="sentBackPortefeuille"><span class="fe fe-arrow-left-circle"></span> Retour sur Portefeuille</button>
                    </div>
                </div>
                <div class="card-body pt-4">
                    <div class="grid-margin">
                        <div class="tab-content">
                            <div class="tab-pane active" id="nav-0" role="tabpanel" aria-labelledby="nav-0-tab">
                                <div class="table-responsive">
                                    <table class="table table-hover table-bordered text-nowrap mb-0">
                                        <thead class="border-top success02">
                                            <tr>
                                                <th class="bg-transparent border-bottom-0 fw-bold text-center">Plan P4W</th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">Composante à lier</th>
                                                <th class="bg-transparent border-bottom-0 fw-bold">Actions</th>
                                            </tr>
                                        </thead>
                                        <template v-for="(action, aIndex) in filtersItems">
                                            <tbody :key="'project-' + aIndex">
                                                <tr class="bg-primary-transparent cursor-pointer transition-all" 
                                                    @click="toggleCollapse(action)">
                                                    <td class="ps-1">
                                                        <i :class="isCollapsed(action) ? 'fe fe-minus' : 'fe fe-plus'"></i>
                                                        {{ action.projectSubject }}
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                </tr>
                                            </tbody>
                                            <tbody v-show="isCollapsed(action)">
                                                <tr v-for="(task, tIndex) in getTasksForProject(action.msdynProjectId)" 
                                                :key="'task-' + task.msdynProjectTaskId" class="bg-secondary-transparent ">
                                                    <td>
                                                        {{ task.taskSubject }}
                                                        <input type="hidden" v-model="payload.msdynProjectTaskId" v-value="task.msdynProjectTaskId" />
                                                    </td>
                                                    <td class="ps-7 ">
                                                        <div v-if="task.outlineLevel === 2">
                                                            <multi-select v-model="payload.idComposante" deselect-label="Sélectionné" select-label="" :options="composantes"
                                                                            placeholder="Sélectionné la composante" label="nomComposante" track-by="idComposante" :searchable="true"
                                                                            :custom-label="o => o.idComposante + ' - ' + o.nomComposante" @select="selectComposanteForLiaison(payload.idComposante, task.msdynProjectTaskId)">
                                                                <template slot="singleLabel" slot-scope="{ option }">
                                                                    <strong> {{ option.nomComposante }}</strong>
                                                                </template>
                                                                <span slot="noOptions">
                                                                    <strong>Liste Vide</strong>
                                                                </span>
                                                                <span slot="noResult">
                                                                    <strong>Aucun Résultat</strong>
                                                                </span>
                                                            </multi-select>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <button class="btn text-warning btn-sm" @click.prevent="showDetail(task)"
                                                            data-bs-toggle="tooltip" title="Voir le détail"
                                                            data-bs-original-title="Voir le détail"><span
                                                                class="fe fe-eye fs-18"></span></button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </table>
                                </div>
                                <div class="text-center mt-3">
                                    <button type="button" @click.prevent="submitLiaisons(listIdValidation)"
                                        class="btn btn-success mr-4" :disabled="listIdValidation.length === 0">
                                        <i class="fe fe-check-square"></i> Enregistrer les liaisons</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="detail-composante-meteo" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-primary text-white">
                            <h6 class="modal-title fw-bold" style="font-size: 16px;">Détail du projet P4W</h6><button aria-label="Close" class="btn-close text-white"
                                data-bs-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <ul class="row p-3">
                                <li class="col-lg-12 mb-2">
                                    <h4 class="fw-bold">Nom du projet</h4>
                                </li>
                                <li class="col-lg-12 mb-2">
                                    
                                </li>
                            </ul>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-gray" data-bs-dismiss="modal">Fermer</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { reduce } from "lodash";
import * as lang from "vuejs-datepicker/src/locale";
import Composantes from './Composantes.vue';
export default {
    name: "Meteo",
    data() {
        return {
            lang: lang, loading: false, showList: true,
            payload: {msdynProjectTaskId: {}, idComposante: {},}, save: true,
            composantes: [], classeurs: [], classeur: {}, lesComposantes: [], composante: {}, meteos: [], etatComposantes: [], statutComposantes: [],
            meteoEvaluer: {}, listIdValidation: [], lesmeteos: [],
            currentPage: 1,
            perPage: 10,
            currentSort: 'composante',
            currentSortDir: 'asc',
            collapsedRows: [],
            collapsedItems: new Set(), 
        }
    },
    computed: {
        ...mapGetters({ items: 'operation/p4wprojectsList' }),
        sortedItems() {
            if (this.lesmeteos && this.lesmeteos.length > 0) {
                this.lesmeteos = this.lesmeteos    
            }else{
                this.lesmeteos = this.items
            }
            return this.lesmeteos.sort((a, b) => {
                const aVal = this.resolveSortValue(a);
                const bVal = this.resolveSortValue(b);
                if (this.currentSortDir === 'asc') {
                return aVal > bVal ? 1 : -1;
                } else {
                return aVal < bVal ? 1 : -1;
                }
            });
        },
        fr() {
          return this.lang.fr;
        },
        filtersItems() {
            return this.items.filter(item => item.outlineLevel === 1) || [];
        },
        getTasksForProject() {
            return (projectId) => {
                return this.items.filter(item => 
                    item.msdynProjectId === projectId && item.outlineLevel === 2
                );
            }
        },
        pageCount() {
            return Math.ceil(this.items.length / this.perPage);
        },
    },
    methods:{
        ...mapActions('operation', ['fetchP4wProjects', ]),
        toggleCollapse(action) {
            const projectId = action.msdynProjectId;
            
            if (this.collapsedItems.has(projectId)) {
                this.collapsedItems.delete(projectId);
            } else {
                this.collapsedItems.add(projectId);
            }
            
            // Forcer la réactivité Vue (si nécessaire)
            this.$forceUpdate();
        },
        isCollapsed(action) {
            return this.collapsedItems.has(action.msdynProjectId);
        },
        sortBy(column) {
            if (this.currentSort === column) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSort = column;
                this.currentSortDir = 'asc';
            }
        },
        changePage(page) {
            if (page >= 1 && page <= this.pageCount) {
                this.currentPage = page;
            }
        },
        resolveSortValue(item) {
            const val = item[this.currentSort];
            if (this.currentSort === 'composante') {
                return item.idComposante?.idComposante + ' - ' + item.idComposante?.nomComposante;
            }
            return typeof val === 'string' ? val.toLowerCase() : val;
        },
        initPayload() {
            return this.payload = {msdynProjectTaskId: {}, idComposante: {},};
        },
        showForm() {
            this.save = true;
            this.initPayload();
            this.showList = false;
        },
        showFormMeteo(item) {
            this.payload.idComposante = {...item};
            this.save = true;
            this.showList = false;
        },
        sentBack() {
            this.showList = true;
            this.initPayload();
            this.onSearch();
        },
        sentBackMeteos() {
            this.$router.push({ name: 'meteos' });
        },
        sentBackPortefeuille(){
            this.$router.push({ name: 'composantes', params: { showList: true }})
        },
        onSearch(offset) {
            this.$loading(true);
            if (offset > 0) this.option.page = offset - 1;
            //this.$router.push({ query: this.option }).catch(() => { });
            this.fetchP4wProjects(this.option).finally(() => this.$loading(false));
        },
        edit(value){
            this.$loading(true);
            this.save = false;
            this.payload = {...value};
            this.hideModal1();
            this.showForm();
            this.$loading(false);
        },
        drop(item){
            const self = this;
            swal({
                title: "Confirmation",
                text: "Etes-vous sûr de vouloir supprimer la météo ?",
                type: "warning",
                showCancelButton: true,
                closeOnConfirm: false,
                cancelButtonText: "Annuler",
                confirmButtonText: "Supprimer",
                confirmButtonColor: "#7db0b2",
                cancelButtonColor: "#FF0000",
                showLoaderOnConfirm: true
            }, function(result) {
                if (result === true) {
                    self.$loading(true);
                    self.$http.delete('/meteo/' + item.id)
                    .then(({data}) => {
                        swal('Information!', 'Météo supprimée avec succès.', 'success');
                        self.onSearch();
                        self.showList = true;
                    })
                    .catch((error) => {
                        swal('Information!', 'Une erreur est survenue lors de la suppression. ' + error, 'warning');
                    })
                    .finally(() => self.$loading(false));
                }
            });
        },
        hideModal1() {
            $('#detail-composante-meteo').modal('hide');
        },
        showDetails(item) {
            this.$loading(true);
            $('#detail-composante-meteo').modal('show');
            this.$loading(false);  
        },
        selectComposanteForLiaison(item, msdynProjectTaskId) {
            const indexValeur = this.listIdValidation.indexOf(item.idComposante);
            if (indexValeur === -1) {
                console.log("selectionnerrrrrrrrrr")
                this.listIdValidation.push({msdynProjectTaskId: msdynProjectTaskId, idComposante: item.idComposante});
            } else {
                this.listIdValidation.splice(indexValeur, {msdynProjectTaskId: msdynProjectTaskId, idComposante: item.idComposante});
            }
            console.log(this.listIdValidation)
        },
        submitLiaisons(listIdValidation){
            console.log(listIdValidation);
            const self = this;
            swal({
                title: "Confirmation",
                text: "Etes-vous sûr de vouloir enregistrer les liaisons ?",
                type: "warning",
                showCancelButton: true,
                closeOnConfirm: false,
                cancelButtonText: "Annuler",
                confirmButtonText: "Enregistrer",
                confirmButtonColor: "#7db0b2",
                cancelButtonColor: "#FF0000",
                showLoaderOnConfirm: true
            }, function(result) {
                if (result === true) {
                    self.$loading(true);
                    self.$http.post('/p4wProjects/assignation', listIdValidation)
                    .then(({data}) => {
                        if (data) {
                            swal('Information!', data, 'success');
                            self.listIdValidation = [];
                            self.window.location.reload();
                        } else {
                            swal('Information!', data, 'warning');
                        }
                    })
                    .catch((error) => {
                        swal('Information!', 'Une erreur est survenue lors de la liaison. ' + error, 'error');
                        console.error('Une erreur est survenue lors de la liaison :', error);
                    })
                    .finally(() => {
                        self.$loading(false);
                    })
                }
            });
        },
        runCheck(id, event){
            this.$loading(true);
            switch (id) {
                case 0:
                    this.$http.get(`/meteo/notValidated`)
                    .then(({data}) =>{
                        if (data) {
                            this.items = data;
                            this.lesmeteos = data?.content;
                        } else {
                            this.lesmeteos = [];
                            swal('Information!', 'Aucune météo à valider disponible.', 'warning');
                        }
                    })
                    .catch((error) => {
                        swal('Information!', 'Erreur lors de la récupération des météos à valider : ' + error, 'error');
                        console.error('Erreur lors du chargement des météos :', error);
                    })
                    .finally(() => {
                        this.$loading(false);
                    });
                break;
                case 1:
                this.$http.get(`/meteo/notValidated`)
                    .then(({data}) =>{
                        if (data.length > 0) {
                            this.lesmeteos = data;
                        } else {
                            this.lesmeteos = [];
                            swal('Information!', 'Aucune météo à valider disponible.', 'warning');
                        }
                    })
                    .catch((error) => {
                        swal('Information!', 'Erreur lors de la récupération des météos à valider : ' + error, 'error');
                        console.error('Erreur lors du chargement des météos :', error);
                    })
                    .finally(() => {
                        this.$loading(false);
                    });
                break;
                case 2:
                this.$http.get(`/meteo/validated`)
                    .then(({data}) =>{
                        if (data.length > 0) {
                            this.lesmeteos = data;
                        } else {
                            this.lesmeteos = [];
                            swal('Information!', 'Aucune météo validée disponible.', 'warning');
                        }
                    })
                    .catch((error) => {
                        swal('Information!', 'Erreur lors de la récupération des météos validées : ' + error, 'error');
                        console.error('Erreur lors du chargement des météos :', error);
                    })
                    .finally(() => {
                        this.$loading(false);
                    });
                break;
            
                default:
                this.onSearch();
                break;
            }
        },
    },
    created() {
        this.onSearch();
        this.$http.get('/composantes/all')
            .then(({data}) =>{
                this.composantes = data;
            });
    }
}
</script>

<style>

</style>